import { CardHeader } from "@libs/zapi-ui/shadcn";
import { TViewMode } from "../model/types";
import { CaretLeft } from "@phosphor-icons/react";

type TProps = {
  onChangeViewMode: (viewMode: TViewMode) => void;
  reviewedSlot: React.ReactNode;
};

export function EvidenceHeader({ reviewedSlot, onChangeViewMode }: TProps) {
  return (
    <CardHeader className="flex flex-col gap-4 border border-innoveraZinc-100 rounded-t-[8px] text-zinc-500 text-[14px] py-2 px-2">
      <div className="flex">
        <div
          className="flex gap-1 cursor-pointer items-center justify-center"
          onClick={() => onChangeViewMode("claim")}
        >
          <CaretLeft className="h-4 w-4 text-innoveraZinc-700" />
        </div>
        {reviewedSlot}
      </div>
    </CardHeader>
  );
}
